const WARNINGS = {
  newReport:
    'Users must save new or updated reports before changing pagination or searching holders',
  newHolder: 'Users must save new holders before searching holders',
  error422:
    'There was an error in saving this report for the selected date. You can update a report for another date or contact the Irwin team for support.',
}

export { WARNINGS }
